/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BoviclicComponent} from './boviclic/boviclic.component';
import {BoviclicErrorComponent} from './boviclic-error/boviclic-error.component';
import {CguComponent} from './cgu/cgu.component';
import {CgvComponent} from './cgv/cgv.component';
import {Error403Component} from './error-403/error-403.component';
import {Error404Component} from './error-404/error-404.component';
import {Error500Component} from './error-500/error-500.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {HelpComponent} from './help/help.component';
import {HistoryComponent} from './history/history.component';
import {HomeComponent} from './home/home.component';
import {LoginComponent} from './login/login.component';
import {MaintenanceComponent} from './maintenance/maintenance.component';
import {PrivacyComponent} from './privacy/privacy.component';
import {ProfileComponent} from './profile/profile.component';
import {RemovalComponent} from './removal/removal.component';
import {RemovalPointsComponent} from './removal-points/removal-points.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {InputsModule} from '../_shared/inputs/inputs.module';
import {SelectsModule} from '../_shared/selects/selects.module';
import {MaterialModule} from '../material.module';
import {CDKModule} from '../cdk.module';
import {RoutingModule} from '../routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {DialogsModule} from '../_shared/dialogs/dialogs.module';
import {DisplaysModule} from '../_shared/displays/displays.module';
import {LayoutModule} from '../layouts/layout.module';
import {ServicesModule} from '../_services/services.module';
import {TablesModule} from '../_shared/tables/tables.module';
import {AdaptersModule} from '../_shared/adapters/adapters.module';
import {PayPalCanceledComponent} from './pay-pal-canceled/pay-pal-canceled.component';
import {PayPalValidatedComponent} from './pay-pal-validated/pay-pal-validated.component';
import {CertComponent} from './cert/cert.component';
import {ProvaltBannerCollectableComponent} from "../provalt-banner-collectable/provalt-banner-collectable.component";

@NgModule({
  declarations: [
    BoviclicComponent,
    BoviclicErrorComponent,
    CguComponent,
    CgvComponent,
    Error403Component,
    Error404Component,
    Error500Component,
    ForgotPasswordComponent,
    HelpComponent,
    HistoryComponent,
    HomeComponent,
    LoginComponent,
    MaintenanceComponent,
    PayPalCanceledComponent,
    PayPalValidatedComponent,
    PrivacyComponent,
    ProfileComponent,
    RemovalComponent,
    RemovalPointsComponent,
    ResetPasswordComponent,
    CertComponent
  ],

  exports: [
    BoviclicComponent,
    BoviclicErrorComponent,
    CguComponent,
    CgvComponent,
    Error403Component,
    Error404Component,
    Error500Component,
    ForgotPasswordComponent,
    HelpComponent,
    HistoryComponent,
    HomeComponent,
    LoginComponent,
    MaintenanceComponent,
    PayPalCanceledComponent,
    PayPalValidatedComponent,
    PrivacyComponent,
    ProfileComponent,
    RemovalComponent,
    RemovalPointsComponent,
    ResetPasswordComponent
  ],
    imports: [
        AdaptersModule,
        BrowserAnimationsModule,
        BrowserModule,
        CDKModule,
        DialogsModule,
        DisplaysModule,
        FormsModule,
        InputsModule,
        LayoutModule,
        MaterialModule,
        ReactiveFormsModule,
        RoutingModule,
        SelectsModule,
        ServicesModule,
        TablesModule,
        ProvaltBannerCollectableComponent
    ]
})

export class PagesModule {
}
